import moment from 'moment';
import React, { useEffect, useState } from 'react'
import Heatmap from '../../components/heatmap'
import Layout from '../../components/Layout';
import useTheme from '../../hooks/useTheme';
import { exportHeatmapDataApi, getHeatmapDataApi } from '../../services/analytics';
import Datepicker from '../../components/datepicker/datepicker'
import MonthPicker from '../../components/datepicker/monthPicker.'
import RandomDatePicker from '../../components/datepicker/randomDatePicker'
import WeekPickers from '../../components/datepicker/weekPicker'
import DateRangePicker from '../../components/datepicker/dateRangePicker';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { startLoader, stopLoader } from '../../lib/global';
const HeatmapPage = () => {
    const [theme, themeType] = useTheme()
    const [data, setData] = useState([]);
    const [activeFilter, setActiveFilter] = useState('week')
    const [filterDate, setFilterDate] = useState(null)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const cardStyle = {
        backgroundColor: theme.map.bgColor,
        color: theme.textColor,
        boxShadow: theme.map.boxShadow
    }
    const menuId = 'primary-more-icon';
    

    useEffect(()=>{
        if(filterDate){
            const filter = {
                startDate: filterDate.startDate,
                endDate: filterDate.endDate,
            }
            getHeatmapDataApi(filter)
            .then(res=>{
                if(res && res.data && res.data.data && res.data.data.series && res.data.data.series[0]){
                    const result = res.data.data.series[0]?.data;
                    setData(result)
                }
            })
            .catch(error=>{
                console.error(error);
            })
        }
    },[filterDate])
    


    const handleFilterClick = (event) => {
        const value = event?.target?.id
        setActiveFilter(value)
    }
    const handleChange = (data) => {
        console.log('data', data)
        if(activeFilter === 'randomDate'){
            if(!data || !data.length){
                data[0] = {
                    startDate: moment().startOf('day').toDate().valueOf(),
                    endDate: moment().endOf('day').toDate().valueOf()
                }
            }
            setFilterDate(data)
        }else if(activeFilter === 'dateRange'){
            if(!data.start || !data.end) return;
            setFilterDate({
                startDate: data?.start,
                endDate: data?.end,
            })
        }else{
            setFilterDate({
                startDate: data?.startDate,
                endDate: data?.endDate,
            })
        }
    }

    const pickers = () => {
        switch(activeFilter){
            case "week":
                return (
                    <WeekPickers 
                        color="#fff"
                        handleChange={handleChange} />
                )
            case "month":
                return (<MonthPicker color="#fff" handleChange={handleChange}  />)
            case "today":
                return (<Datepicker color="#fff" handleChange={handleChange}  />)
            case "randomDate":
                return (<RandomDatePicker color="#fff" handleChange={handleChange}  />)
            case "dateRange":
                return (<DateRangePicker color="#fff" handleDateChange={handleChange}  />)

            default:
                return(<></>)
        }
    }

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleExportData = () => {
        handleMenuClose()
        startLoader()
        // setTimeout(() => {
        //     stopLoader()
        // }, 1000); 
        const payload = {
            startDate: filterDate.startDate,
            endDate: filterDate.endDate,
        }
        exportHeatmapDataApi(payload)
        .then((res)=>{
            // downloadUserSheet(res.data)
            // fileDownload(res.data, 'data.xlsx')
            stopLoader()
        })
        .catch(error=>{
            console.error(error)            
            stopLoader()
        })
    }
    const renderMenu = (
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          id={menuId}
          keepMounted
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          
        >
          <MenuItem onClick={handleExportData}>
            <IconButton>
                <SystemUpdateAltIcon/>
            </IconButton>
            <Typography >Export</Typography>
          </MenuItem>
        </Menu>
      );

    return (
        <Layout>
            <div style={cardStyle} className="card col-12 p-0 pt-3">
                <div className="row col-12 analytics__body__header justify-content-end">
                            <div className="col-xs-6 col-md-auto mr-auto ml-3">
                                <ul className={`buttonwrapper filter_${'dark'}`}>
                                    <li id="today" className={activeFilter == "today" ? 'active' : ''} onClick={handleFilterClick}>
                                        <label id="today">TODAY</label>
                                    </li>
                                    <li id="week" className={activeFilter == "week" ? 'active' : ''} onClick={handleFilterClick}>
                                        <label id="week">WEEK</label>
                                    </li>
                                    <li id="month"className={activeFilter == "month" ? 'active' : ''} onClick={handleFilterClick}>
                                        <label id="month">MONTH</label>
                                    </li>
                                    {/* <li id="year" className={activeFilter == "year" ? 'active' : ''} onClick={()=>{handleFilterClick(4)}}>
                                        <label id="l2">YEAR</label>
                                    </li> */}
                                    
                                    <li id="dateRange" className={activeFilter == "dateRange" ? 'active' : ''} onClick={handleFilterClick}>
                                        <label id="dateRange" className="small">DATE RANGE</label>
                                    </li>
                                </ul>
                            </div>
                        
                            <div className="ml-auto row">
                                {pickers()}
                                <IconButton
                                    aria-label="show more"
                                    aria-controls={menuId}
                                    aria-haspopup="true"
                                    color="inherit"
                                    style={{
                                        padding: "8px 0 0 8px",
                                        display: "flex",
                                        alignItems: "flex-start",
                                        cursor: 'default'
                                    }}
                                    >
                                        <MoreVertIcon onClick={handleMenuOpen} style={{color: "#fff", cursor: 'pointer'}} />
                                    </IconButton>
                            </div>
                </div>
            </div>
            <Heatmap
                height={"calc( 100% - 77px )"}
                data={data}
            />
            {renderMenu}
        </Layout>
    )
}

export default HeatmapPage
